/**
 * Rule: Validates input is Required.
 *
 * @returns {function} - a function returning an Array with the validation result.
 * @param {any} value - text value from input
 * [boolean, string] - A boolean that indicates wether the input is valid and a string with the error message.
 */

export default function isRequired() {
  return (value) => {
    const message = `is Required`;
    if (value === null || value === undefined) {
      return [false, message];
    }

    if (typeof value === 'string' && value?.trim().length === 0) {
      return [false, message];
    }

    return [true, ''];
  };
}
